import React from 'react';

// Create a context with no initial values.
export const SearchContext = React.createContext();

export default SearchContext;
